import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

import * as O from '../../utils/object';
import classnames from '../../utils/classnames';

import { setSelection, cancelSelection } from '@angellira/top-app-bar';

import {
  fetchQuery,
  ERROR_QUERY_INCOMPLETE,
  ERROR_NO_HOMOLOGATOR,
  ERROR_FORBIDDEN
} from '../../services/query';

import { getDriverTypes } from '../../services/driver';

import makeTrashable from 'trashable';

import To from '../../components/to';
import async from '../../components/async';
import PageTitle from '../../components/page-title';
import PageContainer from '../../components/page-container';
import ConfirmDialog from '../../components/confirmation-dialog';
import { HomologatorConsumer } from '../../components/homologator-context';
import ErrorInfo from '../../components/error-info';

import { NoHomologator } from '../query';

import generateCSV from '../../utils/csv';
import resolveSortings, { SORT_ASC, SORT_DESC } from '../../utils/order-to-query';

import PrintDialog from '../../components/print-table-dialog';
import ListingFilter from '../../components/listing/filter';
import AppendableInput from '../../components/listing/typeSelector';
import ListingSearchBar from '../../components/listing/searchbar';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  Adaptable,
  Headings,
  Head,
  Content,
  Record,
  Cell
} from '@angellira/adaptable';

import TableSortLabel from '@material-ui/core/TableSortLabel';
import TablePagination from '@material-ui/core/TablePagination';

import AutorenewIcon from '@material-ui/icons/Autorenew';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import styles from './styles.css';
import { noPrint } from '../../static/print.css';

import { ModalIntegrated } from '../../components/modalIntegrated';
import { findDriver, validityCnh, validityValues } from '../../services/driver';

export function rowTypeByValidity(validity) {
  if(validity < 0)
    return 'danger';
  else if (validity >= 0 && validity < 10)
    return 'caution';
  else if (validity >= 10 && validity <= 20)
    return 'warning';
  else
    return 'success';
}

function EnhancedRowElement(props) {
  const {
    DetailsElement,
    columns,
    extra: {
      avatar = '',
      rowType,
      unlinked
    } = {},
    loading,
    details,
    selected,
    onSelect,
    onClickToCollapse,
    open
  } = props;

  const cssClasses = {
    [styles.openRow]: open,
    [styles[rowType]]: !!rowType,
  };

  return <Record
    className={classnames(cssClasses)}
    loading={loading}
    onSelect={unlinked === undefined ? false: unlinked ? Function.prototype: onSelect}
    selected={selected}
    open={open}
    onClickToCollapse={onClickToCollapse}
    collapsibleActionButton
    openIcon={<ExpandMoreIcon />}
    closeIcon={<ExpandLessIcon />}
    collapsible={<DetailsElement loading={loading} details={details} />}
  >
    <Cell className={noPrint} padding="checkbox">
      <Checkbox
        color="primary"
        checked={selected}
        onChange={onSelect}
        disabled={unlinked === undefined ? false: !!unlinked}
      />
    </Cell>
    <Cell>{avatar}</Cell>
    {
      columns.map((def, i) => <Cell key={i}>{def}</Cell>)
    }
  </Record>;
}

const EnhancedRow = React.memo(EnhancedRowElement);

export class Listing extends Component {
  static defaultProps = {
    setSelection: Function.prototype,
    cancelSelection: Function.prototype,
    selectedExtractorFn: ({ id }) => id,
    dataToColumnsFn: data => Object.values(data),
    dataToExtraFn: () => ({}),
    onValueChange: Function.prototype
  }

  state = {
    loading: false,
    printShown: false,
    loadGuard: 1,
    dialog: {
      title: '',
      text: '',
      confirmation: null
    },
    driverTypes: [],
    driverTypeSelected: [],
    vehicleTypes: [
      { id: 1, description: 'Fixo' },
      { id: 3, description: 'Agregado' },
      { id: 4, description: 'Terceiro' },
    ],
    vehicleTypesSelected: [],
    rowCollapsed: [],
    rowLoading: [],
    rowDetails: [],
    list: [],
    search: '',
    pagination: {
      page: 0,
      perPage: 10,
      total: 10
    },
    prime: 0,
    customTemplate: null,
    sorting: {},
    input: {
      search: ''
    },
    situation: [],
    showUnbound: false,
    selection: [],
    openModalIntegrated: false,
    drivers: [],
    validityValues: {}
  }

  // Cancelable Promises to rows "details"
  rowFetchPromise = {};

  // Memoizing calls to rows "details"
  rowFetchMemo = {};

  dataQuerier = null;

  constructor(props) {
    super(props);

    if (this.props.list)
      this.state = O.compose(this.state, this.prepareRemoteData(this.props.list));

    if (this.props.pagination)
      this.state.pagination = this.props.pagination;
  }

  componentWillUnmount() {
    this.props.cancelSelection();
    // Trash possibly running HTTP queries
    Object.keys(this.rowFetchPromise).forEach(x => this.rowFetchPromise[x].trash());
    this.dataQuerier && this.dataQuerier.trash();
  }

  handlePrimeChange(key, value) {
    this.setState({ [key]: value });
  }

  startLoading() {
    this.setState({ loading: true });
  }

  stopLoading() {
    this.setState({ loading: false });
  }

  queryData = async() => {
    const {
      pagination: { page: newPage, perPage },
      search,
      sorting,
      situation,
      showUnbound,
      driverTypeSelected,
    } = this.state;

    if (this.dataQuerier)
      this.dataQuerier.trash();

    this.startLoading();

    this.dataQuerier = makeTrashable(
      this.getOverdueQueries({
        page: newPage,
        perPage,
        q: search,
        unbound: showUnbound,
        filter: situation,
        sort: resolveSortings(sorting),
        driverTypes: JSON.stringify(driverTypeSelected),
        vehicleTypes: JSON.stringify(this.state.vehicleTypesSelected)
      })
    );

    const { data: { total, data } } = await this.dataQuerier;

    this.setTotal(total);

    return new Promise(resolve => this.setState(
      this.prepareRemoteData(data),
      () => (this.stopLoading(), resolve())
    ));
  }

  getQueryDriverTypes = async() => {
    return getDriverTypes()
      .then(({ data }) => {
        if (data.length === 0) {
          this.setState({ driverTypes: [] });
        } else {
          const formattedData = data.map(item => {
            item.description = String(item.description);
            return item;
          });

          this.setState({ driverTypes: formattedData });
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ driverTypes: [] });
      });
  }

  getOverdueQueries(options) {
    return this.props.overdueQueriesFn(options);
  }

  getQueryDetails(subject) {
    return this.props.queryDetailsFn(subject);
  }

  makeRequery(subjects) {
    this.startLoading();
    return this.props.requeryFn(subjects);
  }

  makeUnbind(subjects) {
    this.startLoading();
    return this.props.unbindFn(subjects);
  }

  dataToColumns(data) {
    return this.props.dataToColumnsFn(data);
  }

  dataToExtra(data) {
    return this.props.dataToExtraFn(data);
  }

  getSelectionExtractor(item) {
    return this.props.selectedExtractorFn(item);
  }

  getDataToDetails(item) {
    return this.props.dataToDetailsFn
      ? this.props.dataToDetailsFn(item)
      : this.getSelectionExtractor(item);
  }

  prepareRemoteData(data) {
    const filteredData = data.filter(x => x !== null);
    return {
      list: filteredData,
      // All rows are closed, and not loading when data is fetched
      rowCollapsed: data.map(() => false),
      rowLoading: data.map(() => false),
    };
  }

  setTotal(total) {
    return this.setState(s => ({
      pagination: { ...s.pagination, total }
    }));
  }

  isSelected = item => this.props.selection.includes(this.getSelectionExtractor(item));

  isAllSelected = () => this.extractList().every(i => this.isSelected(i));

  selectAll() {
    this.props.setSelection(this.extractList().map(x => this.getSelectionExtractor(x)));
  }

  extractList = () => this.state.list.filter( x => x.unlinked === undefined
    ? x
    : x.unlinked
      ? false
      : x
  );

  unselectAll() { this.props.setSelection([]); }

  getSelected() { return this.props.selection; }

  successSnack = (message) => {
    return this.props.enqueueSnackbar(message, { variant: 'success' });
  }

  errorSnack = (message) => {
    return this.props.enqueueSnackbar(message, { variant: 'error' });
  }

  warningSnack = (message) => {
    return this.props.enqueueSnackbar(message, { variant: 'warning' });
  }

  handleConfirmation = (confirmed = true) => this.state.dialog.confirmation(confirmed);

  clearDialog() { return this.setState({ dialog: { title: '' } }); }

  unbindConfirmation() {
    return new Promise(res => this.setState({
      dialog: {
        title: 'Desvincular Selecionados',
        text: 'Você deseja desvincular as consultas selecionadas?',
        confirmation: res,
      }
    }));
  }

  requeryConfirmation() {
    return new Promise(res => this.setState({
      dialog: {
        title: 'Recadastrar Selecionados',
        text: 'Você deseja recadastrar as consultas selecionadas?',
        confirmation: res,
      }
    }));
  }

  showPrint(printShown = true) {
    return new Promise(res => this.setState({ printShown }, res));
  }

  handleUnbind = () => this.unbindConfirmation()
    .then(confirmed => confirmed ? this.makeUnbind(this.getSelected()) : Promise.reject('canceled'))
    .then(() => {
      this.successSnack('As consultas selecionadas foram desvinculadas!');
      this.unselectAll();
      this.queryData();
    })
    .catch(e => e !== 'canceled' && Promise.reject(e))
    .catch(({ data: { message }}) =>
      this.errorSnack(`Ocorreu um erro ao desvincular as consultas: ${message}`)
    ).finally(() => (this.stopLoading(), this.clearDialog()));

  handleRegisterValidation = (data) => {
    const succesList = [];
    for (const key in data) {
      if (data[key].error) {
        this.errorSnack(
          `${data[key].error} [${data[key].towId ||
            data[key].cabId || data[key].queryId}]`
        );
      } else {
        succesList.push(data[key].otnetCode);
      }
    } if (succesList.length) {
      this.successSnack(
        `Recadastro registrado com sucesso! [${succesList}]`
      );
    }
  }

  handleRegister = () => {
    return this.requeryConfirmation()
      .then(confirmed => {
        if (!confirmed) {
          return Promise.reject('canceled');
        }

        const { prime, customTemplateId } = this.state;
        const requestData = {
          prime: prime || 0,
          customTemplateId: customTemplateId || null,
          ids: this.getSelected()
        };

        return this.makeRequery(requestData);
      })
      .then(response => {
        this.handleRegisterValidation(response.data);
        this.unselectAll();
        return this.queryData();
      })
      .catch(error => {
        if (error === 'canceled') {
          return;
        }

        if (error.response && error.response.data) {
          const { response: { data: { error: errorCode, incomplete } } } = error;

          if (errorCode === ERROR_QUERY_INCOMPLETE) {
            return this.errorSnack(`
              Não foi possível recadastrar as consultas, pois apresentam dados
              incompletos: ${incomplete.map(x => x.name)}
            `);
          } else if (errorCode === ERROR_NO_HOMOLOGATOR) {
            return this.errorSnack(`
              Não foi possível recadastrar as consultas, pois não há homologadora associada à
              sua empresa. Entre em contato com a AngelLira pelo (49) 4020-1700.
            `);
          } else if (errorCode === ERROR_FORBIDDEN) {
            return this.errorSnack(`
              Não foi possível recadastrar as consultas,
              você não possui autorização para recadastrar alguma das consultas selecionadas.
              Confira os serviços prime, se necessário.
            `);
          }
        }

        return this.errorSnack(`Não foi possível realizar o recadastro. ${error.message || error}`);
      })
      .finally(() => {
        this.setState({ openModalIntegrated: false });
        this.clearDialog();
        this.stopLoading();
      });
  };

  isRowOpen = row => this.state.rowCollapsed[row];

  toggleRow = row => {
    if (!this.state.rowCollapsed[row]) {
      this.setState(this.setRowCollapse(row, true));

      const current = this.state.list[row];
      const memoId = this.getMemoId(current);
      const promise = this.rowFetchPromise[memoId] = this.prepareDetailsPromise(
        current.id,
        this.getDataToDetails(current)
      );

      promise
        .then(data => this.memoizeDetailsResult(
          data,
          { enrichQuery: current }
        ))
        .then(detail => this.setState(this.setRowDetail(row, detail)));
    } else {
      this.setState(this.setRowCollapse(row, false));
    }
  }

  onToggleRow = row => this.toggleRow.bind(undefined, row);

  setRowCollapse = (row, detail) => {
    const rowCollapsed = this.state.rowCollapsed;
    rowCollapsed[row] = detail;
    return { rowCollapsed };
  };

  setRowDetail = (row, detail) => {
    const rowDetails = this.state.rowDetails;
    rowDetails[row] = detail;
    return { rowDetails };
  };

  setRowCollapseLoading = (row, loading = true) => {
    const rowLoading = this.state.rowLoading;
    rowLoading[row] = loading;
    return { rowLoading };
  }

  rowCollapseLoading = row => this.state.rowLoading[row];

  getMemoId(data) {
    return this.getSelectionExtractor(data) || data.id;
  }

  // Check existence of promise for id or create a new one
  prepareDetailsPromise = (queryId, rscId) => this.rowFetchPromise[rscId || queryId]
    || makeTrashable(Promise.all([fetchQuery(queryId), this.getQueryDetails(rscId)]));

  prepareAllRowsPromises() {
    return this.state.list
      .map(item => this.rowFetchPromise[this.getMemoId(item)] = this.prepareDetailsPromise(
        item.id,
        this.getDataToDetails(item)
      ));
  }

  /**
   * Memoizes request results to prevent making the same request over and over again.
   *
   * Allows an `enrichQuery` and `enrichDetails` do add new info to memoized data
   */
  memoizeDetailsResult = (
    [ { data: queryData }, details ],
    { enrichQuery, enrichDetails, memoId = queryData.id } = {}
  ) => {
    const detailsData = Array.isArray(details)
      ? details.map(x => x && x.data)
      : details.data;

    return this.rowFetchMemo[memoId] = {
      queryData: Object.assign(queryData, enrichQuery),
      detailsData: Object.assign(detailsData, enrichDetails),
    };
  }

  allRowsExpanded = () => this.state.rowCollapsed.every(x => x);

  setAllRowsCollapse = collapse => this.setState(s => ({
    rowCollapsed: s.rowCollapsed.map(() => !!collapse)
  }));

  loadAllRowPromises() {
    const rowQueries = this.prepareAllRowsPromises();

    return Promise.all(rowQueries)
      .then(proms => proms.map((data, i) => this.memoizeDetailsResult(
        data,
        { enrichQuery: this.state.list[i], memoId: this.getMemoId(this.state.list[i]) })
      ))
      .then(results => this.setState({ rowDetails: results }));
  }

  toggleExpansions = () => {
    if (this.allRowsExpanded()) {
      this.setAllRowsCollapse(false);
    } else {
      this.startLoading();

      this.loadAllRowPromises()
        .then(() => this.setAllRowsCollapse(true))
        .then(() => this.stopLoading());
    }
  }

  async getAllPagesOfFilters() {
    const { search, situation, showUnbound } = this.state;

    const page = 1;
    const perPage = 'all';

    const { data: { data: list } } = await this.getOverdueQueries({
      page,
      perPage,
      q: search,
      unbound: showUnbound,
      filter: situation,
    });

    const headers = this.props.tableHeader.map(({ content }) => content);
    const lines = list.map(this.dataToColumns.bind(this));

    return [headers, lines];
  }

  genCsv = async() => {
    this.setState({ loading: true });

    const fileHeader = 'data:text/csv;charset=utf-8';

    const [headerKeys, lines] = await this.getAllPagesOfFilters();

    const csv = generateCSV(headerKeys, lines);

    const encodedBody = encodeURI(csv);
    const data = `${fileHeader},${encodedBody}`;

    const a = document.createElement('a');

    a.style.display = 'none';
    a.setAttribute('href', data);
    a.setAttribute('download', 'relatorio.csv');

    this.setState({ loading: false });

    document.body.appendChild(a);
    a.click();

    a.remove();
  }

  handlePrint = () => {
    // Must wait for react re-render to toggle print
    return this.getAllPagesOfFilters()
      .then(([headers, lines]) => new Promise(
        res => this.setState({ printHeaders: headers, printLines: lines }, res))
      )
      .then(() => this.showPrint())
      .then(window.print);
  }

  closePrint = () => {
    // Cleanup
    this.setState({ printHeaders: null, printLines: null });
    this.showPrint(false);
  };

  handleSearchEnter = ev => (ev.key === 'Enter' && this.handleSearch());

  updateSearchQuery(callback) {
    return this.setState({ search: this.state.input.search }, callback);
  }

  handleSearch = (propsSearch) => {
    this.setState({
      driverTypeSelected: propsSearch.employeeTypes ? propsSearch.employeeTypes : [],
      vehicleTypesSelected: propsSearch.vehicleTypesSelected ? propsSearch.vehicleTypesSelected : []
    });
    return this.updateSearchQuery(this.queryData);
  }

  handleSearchInput = ({ target: { value }}) => this
    .setState(current => ({ input: { ...current.input, search: value }}))

  handlePage = (ev, page) =>
    this.setState(s => ({ pagination: { ...s.pagination, page: page + 1 } }), this.queryData);

  handleRowsPage = ({ target: { value } }) => this.setState(s => ({
    pagination: { ...s.pagination, perPage: value }
  }), this.queryData);

  toggleSituation = ({ target: { value }}) => !this.state.situation.includes(value)
    ? this.setState(s => ({ situation: s.situation.concat(value) }))
    : this.setState(s => ({ situation: s.situation.filter(x => x !== value) }))

  toggleUnbound = () => this.setState(s => ({ showUnbound: !s.showUnbound }));

  handleSelection = value => () => !this.props.selection.includes(value)
    ? this.props.setSelection(this.props.selection.concat(value))
    : this.props.setSelection(this.props.selection.filter(x => x !== value))

  handleSelectionAll = () => this.isAllSelected() ? this.unselectAll() : this.selectAll();

  handleTypeChange = (key, value) => {
    this.setState({ [key]: value });
    if (this.props.onValueChange) {
      this.props.onValueChange(key, value);
    }
  }

  sortingDirection = field => this.state.sorting[field];

  isSorting = field => !!this.state.sorting[field];

  removeSorting = (field, callback) => this.setState(state => {
    const sorts = state.sorting;
    delete sorts[field];

    return { sorting: { ...sorts } };
  }, callback);

  sortBy = (field, dir = SORT_ASC, callback) => this.setState(s => ({
    sorting: { ...s.sorting, [field]: dir }
  }), callback);

  handleSortClick = field => () => {
    if (! this.isSorting(field))
      this.sortBy(field, SORT_ASC, this.queryData);
    else if (this.sortingDirection(field) === SORT_ASC)
      this.sortBy(field, SORT_DESC, this.queryData);
    else
      this.removeSorting(field, this.queryData);
  }

  sortingProps = field => ({
    direction: this.sortingDirection(field),
    active: this.isSorting(field),
    onClick: this.handleSortClick(field)
  });

  paginationFormatter = ({ from, to, count }) => `${from}-${to} de ${count}`;
  rowsPerPageOptions = [10, 25, 50];

  async getDriver(driverIdList) {
    const driversPromises = driverIdList.map((item) => findDriver(item));
    const drivers = await Promise.all(driversPromises);
    const driversData = drivers.map(driver => driver.data);
    await Promise.all(driversData.map(async (item, index) => {
      const driver = await validityCnh(item.cpf);
      const queryValidity = new Date();
      const driverCnhValidity = new Date(driver.data.cnhValidity);

      if (queryValidity.toISOString() > driverCnhValidity.toISOString()) {
        return driversData[index].data = { expired: true, render: false };
      }

      driverCnhValidity.setDate(driverCnhValidity.getDate() + 30);
      queryValidity.setDate(queryValidity.getDate() + driver.data.queryValidity);

      driver.data.render = driverCnhValidity.toISOString() < queryValidity.toISOString();

      return driversData[index].data = driver.data;
    }));

    return driversData;
  }

  componentDidMount() {
    validityValues().then(({ data }) => {
      this.setState({ validityValues: data });
    });

    this.getQueryDriverTypes();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.type) { return; }
    if (
      this.props.selection.length > prevProps.selection.length
      && !this.state.validityValues.CPe_Desabilitar_Validade_CNH_Perfil_Securitario
    ) {
      this.setState({ loading: true });
      const driverIdList = this.getSelected().map((item) => {
        // eslint-disable-next-line eqeqeq
        const result = this.state.list.find((x) => x.id == item);
        if (this.props.type === 'driver') { return result?.personId;}
        return result?.driverId;
      });

      if (
        !this.state.drivers.every((item) => item.data.queryValidity)
        || this.state.drivers.length === 0
        || this.state.drivers.length !== driverIdList.length
      ) {
        this.getDriver(driverIdList).then((drivers) => {
          this.setState({ drivers, loading: false });
        });
      } else {
        this.setState({ loading: false });
      }

      const renderList = this.state.drivers.filter((item) => item.data.render);

      if (renderList.length === 0) {
        this.setState({ openModalIntegrated: false });
      }
    }
  }

  handleRemoveDriver = (id) => {
    this.setState({
      drivers: this.state.drivers.filter((item) => item.id !== id),
    });

    const idList = this.props.type === 'driver' ?
      this.state.list.filter((item) => item.personId === id)
      : this.state.list.filter((item) => item.driverId === id);

    if (this.props.type === 'driver') {
      this.props.setSelection(this.props.selection.filter((item) => item !== idList[0].id));
    } else {
      this.handleSelection(String(idList[0].id))();
    }
  }

  handleRemoveDrivers = (remove) => {
    const removeIdList = remove.map((item) => item.id);

    this.setState({
      drivers: this.state.drivers.filter((driver) => !removeIdList.includes(driver.id)),
    });

    const idKey = this.props.type === 'driver' ? 'personId' : 'driverId';
    const idList = this.state.list.filter(item => removeIdList.includes(item[idKey]));

    const newSelection = this.props.selection.filter(
      // eslint-disable-next-line eqeqeq
      (id) => !idList.some((item) => item.id == id)
    );

    this.props.setSelection(newSelection);
  }

  render() {
    const { title, tableHeader } = this.props;
    const { pagination } = this.state;

    const firstPage = pagination.page === 1;
    const lastPage = pagination.page * pagination.perPage >= pagination.total;

    const dataColumns = this.state.list.map(x => this.dataToColumns(x));

    return <PageContainer component="section">
      <PageTitle icon={<AutorenewIcon />}>{title}</PageTitle>

      <ModalIntegrated
        open={this.state.openModalIntegrated}
        onClose={() => this.setState({ openModalIntegrated: false })}
        driversList={this.state.drivers}
        handleRemoveDriver={this.handleRemoveDriver}
        handleRegister={this.handleRegister}
        loading={this.state.loading}
      />

      <PrintDialog
        shown={this.state.printShown}
        headers={this.state.printHeaders || tableHeader.map(({ content }) => content)}
        data={this.state.printLines || dataColumns}
        onClose={this.closePrint}
      />

      <AppendableInput
        loading={this.state.loading}
        onValueChange={this.handleTypeChange}
        prime={this.state.prime}
        customTemplateId={this.state.customTemplateId}
        error={this.state.typeError}
      />

      <Divider />

      <ListingFilter
        originType={this.props.type ? 'driver' : 'vehicle'}
        loading={this.state.loading}
        situation={this.state.situation}
        onToggleSituation={this.toggleSituation}
        onToggleUnbound={this.toggleUnbound}
        unbound={this.state.showUnbound}
        onApply={this.handleSearch}
        className={noPrint}
        driverTypes={this.state.driverTypes}
        vehicleTypes={this.state.vehicleTypes}
      />

      <Divider />

      <ListingSearchBar
        loading={this.state.loading}
        onSearch={this.handleSearch}
        search={this.state.input.search}
        onChangeSearch={this.handleSearchInput}
        onPrintClick={this.handlePrint}
        onExportClick={this.genCsv}
        expansionsToggled={this.allRowsExpanded()}
        onToggleExpansion={this.toggleExpansions}
        className={noPrint}
      />

      <div style={{ overflowX: 'scroll' }}>
        <Adaptable className={styles.tableListing} card={this.props.mobile}>
          <Headings>
            <Head cellProps={{ className: noPrint, padding: 'checkbox' }} hiddenCard>
              <Checkbox
                color="primary"
                onChange={this.handleSelectionAll}
                indeterminate={this.props.selection.length > 0 && !this.isAllSelected()}
                checked={this.isAllSelected()}
              />
            </Head>

            <Head hiddenTable avatar>Avatar</Head>

            {
              tableHeader.map(({ content, sort, title, subtitle, size }) => (
                <Head
                  cellProps={{ style: size ? { minWidth: `${size}ch` } : {} }}
                  key={content}
                  title={title}
                  subtitle={subtitle}
                >
                  {
                    sort
                      ? <TableSortLabel {...this.sortingProps(sort)}>{content}</TableSortLabel>
                      : content
                  }
                </Head>
              ))
            }

            <Head cellProps={{ className: noPrint }} hiddenCard>Ações</Head>
          </Headings>

          <Content>
            {
              this.state.list.map((x, i) => (
                <EnhancedRow
                  DetailsElement={this.props.DetailsElement}
                  key={i}
                  columns={dataColumns[i]}
                  extra={this.dataToExtra(x)}
                  details={this.state.rowDetails[i]}
                  open={this.isRowOpen(i)}
                  loading={this.state.loading || this.rowCollapseLoading(i)}
                  selectOnClick={this.props.selection.length > 0}
                  onSelect={this.handleSelection(this.getSelectionExtractor(x))}
                  selected={this.isSelected(x)}
                  onClickToCollapse={this.onToggleRow(i)}
                />
              ))
            }
          </Content>
        </Adaptable>
      </div>

      <div className={`${styles.tableNav} ${noPrint}`}>
        <Typography component="span" variant="subtitle2">
          {
            this.props.selection.length ? <>
              {this.props.selection.length}
              {this.props.selection.length > 1 ? ' itens selecionados' : ' item selecionado' }
            </> : 'nenhum item selecionado'
          }
        </Typography>

        <div>
          {
            this.state.loading && (
              <CircularProgress className={styles.loadingIcon} color="primary" size={16} />
            )
          }

          <TablePagination
            className={styles.tablePaginationContainer}
            component="div"
            labelDisplayedRows={this.paginationFormatter}
            labelRowsPerPage={'Registros por página:'}
            rowsPerPageOptions={this.rowsPerPageOptions}
            count={pagination.total}
            rowsPerPage={pagination.perPage}
            page={pagination.page - 1}
            onChangePage={this.handlePage}
            onChangeRowsPerPage={this.handleRowsPage}
            nextIconButtonProps={{ disabled: lastPage || this.state.loading }}
            backIconButtonProps={{ disabled: firstPage || this.state.loading }}
          />
        </div>
      </div>

      <div className={`${styles.actions} ${noPrint}`}>
        <Button
          onClick={this.handleUnbind}
          className={styles.btn}
          variant="contained"
          size="large"
          disabled={!this.getSelected().length}
        >
          Desvincular
        </Button>

        <Button
          onClick={() => {
            const remove = this.state.drivers.filter((item) => item.data.expired);
            const removedNames = remove.map((item) => item.name);

            if (this.state.prime !== 0 && !this.state.prime && !this.state.customTemplateId
              || (this.state.prime === 0 && !this.state.customTemplateId)) {
              this.setState({ typeError: true });
              this.errorSnack('Por favor, selecione um tipo de consulta antes de recadastrar.');
              return;
            }

            this.setState({ typeError: false });

            if (remove.length > 0) {
              const message = (
                <div>
                  Atenção! O Recadastro não pode ser realizado pois os motoristas:
                  {removedNames.length && removedNames.map((name, index) => (
                    <React.Fragment key={index}>
                      <br />
                      {name},
                    </React.Fragment>
                  ))}
                  <br />
                  estão com a CNH vencida!
                </div>
              );
              this.warningSnack(message);
              this.handleRemoveDrivers(remove);
              return;
            }
            if (validityValues.CPe_Desabilitar_Validade_CNH_Perfil_Securitario) {
              this.handleRegister();
              return;
            }
            if (
              !this.props.type
              || this.state.drivers.every((item) => item.data.render === false)
            ) {
              if (this.state.drivers.length < 0) {
                this.setState({ openModalIntegrated: true });
                return;
              }
              this.handleRegister();
              return;
            }
            this.setState({ openModalIntegrated: true });
          }}
          className={styles.btn}
          variant="contained"
          size="large"
          color="primary"
          disabled={!this.getSelected().length || this.state.loading}
        >
          Recadastrar
        </Button>
      </div>

      <ConfirmDialog
        onClose={this.handleConfirmation.bind(this, false)}
        onConfirm={this.handleConfirmation.bind(this, true)}
        loading={this.state.dialog.loading || this.state.loading}
        title={this.state.dialog.title}
        open={!!this.state.dialog.title.length}
      >
        {this.state.dialog.text}
      </ConfirmDialog>
    </PageContainer>;
  }
}

const component = connect(
  ({ mobile, topbar: { selection } }) => ({ mobile, selection }),
  bindActionCreators.bind(undefined, { setSelection, cancelSelection })
);

export const SnackedListing = withSnackbar(Listing);

export const ConnectedListing = component(SnackedListing);

export default props => async(() => {
  const pagination = { page: 1, perPage: 10};

  return Promise.all([
    props.overdueQueriesFn(pagination)
  ]).then(([{ data: { total, data } }]) => To(
    <HomologatorConsumer>
      {({ exists, error, homologatorId }) => exists && homologatorId !== 3
        ? <ConnectedListing pagination={{ total, ...pagination }} list={data} {...props} />
        : homologatorId === 3
          ? <NoHomologator/>
          : <ErrorInfo message={
            error.message === undefined
              ? ' '
              : error.message
          } info={ { request: error } }/> }
    </HomologatorConsumer>
  ));
});
